// Flattens the parcel, the logged-in user and the carrier into the one
// object that section criteria are matched against.
import { isSuperUser, seeingAsAnotherCarrier } from '../../utils/permissions'

const buildContext = ({ parcel, user, carrier, carrierRolePermissions }) => ({
  carrier: carrier?.username,
  isIboxen: carrier?.isIboxen === true,
  country: parcel?.location?.address?.country,
  role: user?.role?.name,
  // A super user looking at another carrier is not treated as one here: the
  // point of switching is to see what that carrier sees, and a super user is
  // allowed everything. Their permissions answer for them while they are there.
  isSuperUser: isSuperUser(user) && !seeingAsAnotherCarrier(user, carrier),
  // Theirs come from their roles, which is where their users get them. Not from the carrier's own
  // `allowedTo`: that answers a different set of questions — `usePickups`, `restrictLocations` —
  // and reading it here says no to everything a section asks.
  permissions:
    seeingAsAnotherCarrier(user, carrier) && carrierRolePermissions
      ? carrierRolePermissions
      : user?.role?.allowedTo ?? [],
  status: parcel?.currentStatus,
  flow: parcel?.flow,
  canChangeBoxSize: parcel?.actions?.canChangeBoxSize === true,
  // the parcel carries errors in two different fields; either one counts, and
  // an empty list is no error: the spec wants no empty card
  hasErrors:
    (parcel?.errors?.length ?? 0) > 0 ||
    (parcel?.parcelErrors?.length ?? 0) > 0,
  hasSignatures: (parcel?.signatures?.length ?? 0) > 0,
})

export { buildContext }
